import { Dispatch, SetStateAction, useMemo } from 'react';
import Modal from 'react-modal';
import { NaoConformidadeCliente } from '../../../../../types';
import { Field, FieldArray, Form, Formik } from "formik";
import { CustomErrorMessage } from '../../../../../components/FormComponents/CustomErrorMessage';
import { hasError } from '../../../../../components/FormComponents/utils';
import { FormFieldWrapperColumn } from '../../../../../components/FormComponents/FieldWrapperColumn/FieldWrapperColumn';
import CustomButtonSimple from '../../../../../components/CustomMiscellaneous/CustomButtonSimple';



export function NaoConformidade({
    reclamacaoCliente,
    naoConformidadeOpen,
    setNaoConformidadeOpen,
    pecasEntrega
}: {
    reclamacaoCliente?: NaoConformidadeCliente,
    naoConformidadeOpen: boolean,
    setNaoConformidadeOpen: Dispatch<SetStateAction<boolean>>,
    pecasEntrega: any[]
}) {

    const formInitialValues: Partial<NaoConformidadeCliente> = useMemo(() => ({
        id: reclamacaoCliente?.id,
        pecaEntrega: reclamacaoCliente?.pecaEntrega,
        acoesDeMelhoria: reclamacaoCliente?.acoesDeMelhoria,
        aceite: reclamacaoCliente?.aceite,
        causaParaNaoConformidade: reclamacaoCliente?.causaParaNaoConformidade
    }), [reclamacaoCliente])


    return (
        <Modal className={"justify-self-center justify-center flex w-full h-full p-52 z-[1000]"} isOpen={naoConformidadeOpen}>
            <div className="bg-white opacity-100 flex flex-col w-2/3 rounded-md shadow-lg z-[1200] h-2/3">
                <div className="flex w-full justify-between  bg-rodrimaq-red rounded-t-md p-3">
                    <div className="text-white font-bold">Formulário de não conformidade</div>
                    <div className="text-white cursor-pointer hover:underline" onClick={() => setNaoConformidadeOpen(false)}>Fechar</div>
                </div>
                {/* <Formik
                initialValues={formInitialValues}
                // innerRef={formRef}
                // mutation.mutate(({ ...values }))
                validateOnChange={false}
                onSubmit={(values) => null}
            >
                {(props) => {
                    const { values, errors, touched, handleChange, setFieldValue } = props;

                    return (
                        <Form>
                            <div className="flex">
                                <FormFieldWrapperColumn label={"Data de entrega"} className="w-1/3">
                                    <>
                                        <Field
                                            className="w-full bg-zinc-300"
                                            name={`realDeliveryDate`}
                                            size="small"
                                            as={CustomDatePicker}
                                            onChange={(value: Date) => {
                                                setFieldValue(`realDeliveryDate`, value)
                                            }}
                                            value={values.realDeliveryDate ? values.realDeliveryDate : new Date()}
                                            error={hasError({ errors, touched, name: 'realDeliveryDate' })}
                                            variant={'outlined'}
                                            label={'Data de entrega'} />
                                        <CustomErrorMessage name={`realDeliveryDate`} />
                                    </>
                                </FormFieldWrapperColumn>
                                <FormFieldWrapperColumn label={"Data de entrega (para colaboradores)"} className="w-1/3">
                                    <>
                                        <Field
                                            className="w-full bg-zinc-300"
                                            name={`publicDeliveryDate`}
                                            size="small"
                                            as={CustomDatePicker}
                                            onChange={(value: Date) => {
                                                setFieldValue(`publicDeliveryDate`, value)
                                            }}
                                            value={values.publicDeliveryDate ? values.publicDeliveryDate : new Date()}
                                            error={hasError({ errors, touched, name: 'publicDeliveryDate' })}
                                            variant={'outlined'}
                                            label={'Data de entrega (para colaboradores)'} />
                                        <CustomErrorMessage name={`publicDeliveryDate`} />
                                    </>
                                </FormFieldWrapperColumn>
                                <FormFieldWrapperColumn label={"Data de fim de produção"} className="w-1/3">
                                    <>
                                        <Field
                                            className="w-full bg-zinc-300"
                                            name={`productionReadyDate`}
                                            size="small"
                                            as={CustomDatePicker}
                                            onChange={(value: Date) => {
                                                setFieldValue(`productionReadyDate`, value)
                                            }}
                                            value={values.productionReadyDate ? values.productionReadyDate : new Date()}
                                            error={hasError({ errors, touched, name: 'productionReadyDate' })}
                                            variant={'outlined'}
                                            label={'Data de fim de produção'} />
                                        <CustomErrorMessage name={`productionReadyDate`} />
                                    </>
                                </FormFieldWrapperColumn>
                            </div>

                            <FormFieldWrapperColumn label={"Percentagem"} className={"w-1/2"} >
                                <>
                                    <Field
                                        className="w-full"
                                        name={`percentage`}
                                        as={TextField}
                                        error={hasError({ errors, touched, name: 'percentage' })}
                                        variant={'outlined'}
                                        type={'number'}
                                        label={'Percentagem'} />
                                    <CustomErrorMessage name={"percentage"} />
                                </>
                            </FormFieldWrapperColumn>

                            <div className="flex justify-end mt-3 mr-2">
                                <CustomButtonSimple className="mr-2" text={"Cancelar"} Icon={CloseIcon} onClick={() => onCancel(false)} />

                                <CustomButtonSimple type="submit" text={"Submeter"} Icon={PublishIcon} />
                            </div>

                        </Form>
                    )


                }}



            </Formik> */}

            </div>
        </Modal>
    )



}